import { SafeAreaView } from 'react-native-safe-area-context';
import * as MUTATIONS from '../../state/mutations/UserMatching';
import Button from '../Button/Button';
import React, { useState } from 'react';
import { KeyboardAvoidingView, Modal, StyleSheet, TextInput,  TouchableWithoutFeedback, View} from 'react-native';
import { ParagraphMRegular, mainTypoRegular } from '../../config/designSystem/typography';
import { isIos, isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useBreakpointWidth } from '../../hooks/useBreakpointWidth';
import { useMutation } from '@apollo/client';
import { useStores } from '../../hooks/useStores';

interface ButtonProps {
    onDismiss: () => void;
    mainText: string;
    buttonText: string;
    isVisible: boolean;
    setIsVisible:(visible: boolean) => void;
  }

export const BasicModalFeedback = ({ onDismiss, mainText, buttonText, isVisible, setIsVisible}: ButtonProps) => {
  const {width} = useAvailableDimensions();
  const WIDTH_MODAL = useBreakpointWidth({sm:0.95*width, md:0.8*width, lg:0.7*width});
  const PADDING_HORIZONTAL_MODAL = 25;
  const [notFoundReason] = useMutation(MUTATIONS.SET_NOT_FOUND_WITH_REASON);
  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE?.ASSISTANCE;
  const [message, setMessage] = useState('');

  const modalWrapper = () => {
    return (
      <Modal
        animationType='fade'
        transparent={true}
        visible={isVisible}
        onRequestClose={() => { setIsVisible(false); }}>
        <TouchableWithoutFeedback onPressOut={() => { setIsVisible(false); }}>
          <View
            style={{ flex: 1, backgroundColor:'rgba(0,0,0,0.8)'}}
          >
            <View style={styles.centeredView}>
              {isIos? (<KeyboardAvoidingView
                style={[styles.centeredView]}
                behavior={'padding'}
              >
                <TouchableWithoutFeedback>
                  {modal()}
                </TouchableWithoutFeedback>
              </KeyboardAvoidingView>):
                <TouchableWithoutFeedback>
                  {modal()}
                </TouchableWithoutFeedback>

              }

            </View>
          </View>
        </TouchableWithoutFeedback>
      </Modal>);
  };

  const modal = () => {
    return(
      <View style={[{backgroundColor:'white',
        borderRadius: 40,
        paddingTop: 30,
        paddingBottom:10,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal:PADDING_HORIZONTAL_MODAL,
        width:WIDTH_MODAL}]}>
        <View style={{ justifyContent: 'center', alignItems: 'center'}}>
          <ParagraphMRegular>
            {mainText}
          </ParagraphMRegular>
          <SafeAreaView style={styles.modalInput} >
            <TextInput style={[{marginLeft:10, width:250,height:80, fontFamily:mainTypoRegular}, isWeb && {outline:'none', cursor: 'pointer'}]}
              placeholder={labels?.HELP_DESK_PLACEHOLDER}
              value={message}
              multiline={true}
              autoFocus
              onChangeText={text => setMessage(text)}
              cursor={'pointer'}

            />
          </SafeAreaView>
        </View>
        <View style={{ justifyContent: 'space-around', alignItems: 'center', marginTop: 20 }}>
          <Button
            width={250}
            label={buttonText}
            onPress={async () => {
              await notFoundReason({variables:
               {reason: message }});
              setMessage('');
              onDismiss();
            }}
          />
        </View>
      </View>);
  };


  return(<>
    {modalWrapper()}
  </>);

};
const styles = StyleSheet.create  ({
  centeredView: {
    justifyContent:'center',
    alignItems: 'center',
    flex:1
  },
  modalInput:{
    borderColor:'black',
    borderWidth:1,
    marginTop:20,
    width:250,
    height:80,
    borderRadius:12,
  }
});